import { createGetEndpoint } from '@sonar-software/sonar-http';
import { JiraProject, JiraSelectedProject } from '@types';

export type GetJiraSummaryResponse = {
	apiToken: string;
	connected: boolean;
	url: string;
	username: string;
	webhookUrl: string;
	projects: JiraProject[];
	selectedProjectKey: string;
	selectedProjects: JiraSelectedProject[];
};

export const getJiraSummary = createGetEndpoint<void, GetJiraSummaryResponse>('/api/v3/jira/summary');
